type FetchResponse<TResponseData> = {
	data?: TResponseData;
	headers?: Headers;
	error?: Error;
};

function isJSONResponse(response: Response): boolean {
	const contentType = response.headers.get('Content-Type');

	if (!contentType) {
		return false;
	}

	return contentType.includes('application/json');
}

function handleResponse<TResponseBody>(response: Response): Promise<TResponseBody> {
	const isJSON = isJSONResponse(response);

	if (response.ok) {
		return isJSON ? response.json() : response.text();
	}

	throw new Error('Error handling response');
}

async function safeFetch<TResponseBody>(resource: RequestInfo, options?: RequestInit): Promise<FetchResponse<TResponseBody>> {
	const response = await fetch(resource, options);
	const body = await handleResponse<TResponseBody>(response);

	return {
		data: body,
		headers: response.headers,
	};
}

export async function fetchData<TResponseData>(resource: string, options?: RequestInit): Promise<FetchResponse<TResponseData> | undefined> {
	return safeFetch<TResponseData>(resource, options)
		.then(function (response: FetchResponse<TResponseData>) {
			return response;
		})
		.catch((error) => {
			console.error(error);
			return undefined;
		});
}
